export default function triggerEvent(el, type) {
    if ('createEvent' in document) {
        // modern browsers, IE9+
        var e = document.createEvent('HTMLEvents');
        e.initEvent(type, false, true);
        el.dispatchEvent(e);
    }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/_util/triggerEvent.js
// module id = 1254
// module chunks = 0